import { PageHeader } from "@/components/StatCard";
import { Stat, Section, Loading, Empty, useFetch, money, day } from "./_shared";

export default function Circles() {
  const { data: ov, loading } = useFetch("/admin/circles/overview");
  const { data: list } = useFetch("/admin/circles/list?limit=50");
  const { data: top } = useFetch("/admin/circles/top-coaches");
  if (loading) return <Loading />;
  const t = ov?.totals || {}; const rev = ov?.revenue || {};
  const circles = list?.circles || []; const coaches = top?.coaches || [];

  return (
    <div className="space-y-5">
      <PageHeader eyebrow="Admin" title="Kreise" subtitle="Übersicht, Top-Coaches & Umsatz." />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Kreise" value={t.circles ?? 0} />
        <Stat label="Mitglieder" value={t.unique_members ?? 0} />
        <Stat label="Käufe" value={t.purchases ?? 0} />
        <Stat label="Umsatz gesamt" value={money(rev.all_time_cents)} />
      </div>

      <Section title={`Kreise (${circles.length})`} testId="admin-circles-list">
        {circles.length === 0 ? <Empty text="Keine Kreise." /> : (
          <div className="space-y-2">
            {circles.map((c) => (
              <div key={c.id} className="flex items-center justify-between gap-3 rounded-xl border border-border bg-background p-3">
                <div className="min-w-0"><p className="truncate text-sm font-medium text-foreground">{c.name || "—"}<span className="ml-1 rounded bg-secondary px-1.5 text-[10px] text-muted-foreground">{c.circle_kind}</span></p><p className="truncate text-xs text-muted-foreground">{c.coach?.name || "—"} · {c.member_count} Mitgl.{c.price_cents ? ` · ${money(c.price_cents)}` : ""}</p></div>
                <span className="shrink-0 text-xs text-muted-foreground">{day(c.created_at)}</span>
              </div>
            ))}
          </div>
        )}
      </Section>

      <Section title="Top-Coaches" testId="admin-circles-top">
        {coaches.length === 0 ? <Empty text="—" /> : (
          <div className="space-y-2">
            {coaches.slice(0, 10).map((c, i) => (
              <div key={c.coach_id || i} className="flex items-center justify-between gap-3 rounded-xl border border-border bg-background p-3 text-sm">
                <span className="truncate text-foreground">{i + 1}. {c.name || c.coach_id}</span>
                <span className="shrink-0 text-xs text-muted-foreground">{c.circles} Kreise · {c.members} Mitgl.</span>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
